import { render, staticRenderFns } from "./ListaClienti.vue?vue&type=template&id=8d8eb6da&"
import script from "./ListaClienti.vue?vue&type=script&lang=js&"
export * from "./ListaClienti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports